export var MixpanelEvents = {
    searchboxUsed: "Main page service search used",
    serviceDetailsViewed: "Viewed page Service Details",
    decisionTreeSkipBack: "Decision tree skip back",
    decisionTreeAnswered: "Decision tree answer",
    decisionTreeTabClicked: "Decision tree tab clicked",
    categoryFilterSelected: "Category filter selected",
    serviceQuantityUpdated: "Service quantity updated",
    serviceRemovedFromCart: "Service removed from cart",
    serviceAddedToCart: "Service added to cart",
    proposalGenerated: "Generated proposal",
    proposalGenerationFailed: "Generated proposal failed",
    proposalStatusChanged: "Proposal status changed"
};
